// src/components/TermsAcceptanceModal.js
// Gate shown before a booking is actually submitted: the customer must explicitly Accept or
// Decline the Terms & Conditions, mirroring how the quote/booking flow already confirms other
// choices. Reuses BookingConfirmationModal's visual style rather than introducing a new look.
import React, { useEffect } from "react";
import "./BookingConfirmationModal.css";
import "./TermsAcceptanceModal.css";

const TermsAcceptanceModal = ({ open, onAccept, onDecline }) => {
  useEffect(() => {
    if (!open) return undefined;
    const handleKeyDown = (e) => {
      if (e.key === "Escape") onDecline();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [open, onDecline]);

  if (!open) return null;

  return (
    <div className="booking-modal-backdrop" onClick={onDecline}>
      <div
        className="booking-modal terms-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="terms-modal-title"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 id="terms-modal-title">Terms &amp; Conditions</h3>
        <p className="booking-modal-message">
          Please read and accept our Terms &amp; Conditions before we confirm your booking.
        </p>

        <div className="terms-modal-text">
          <p>
            Original colours that have faded through wear, tear or sunlight cannot be restored,
            nor can the effects of grease, sweat or hair oil always be entirely removed.
          </p>
          <p>
            Quoted prices are estimates only and may change if the actual job differs from the
            original booking, including where payment has already been made.
          </p>
          <p>
            We do not accept responsibility for latent damage or defects not apparent at the time
            of receipt of goods, but which may appear during or result from ordinary and normal
            processing (e.g. dry rot, weak dyes, discolouration, fading, shading, latex/bonding
            deterioration or texture changes in some rugs and carpets).
          </p>
          <p>
            No complaint about any work or service will be considered unless lodged with us
            within 24–48 hours of the work being performed.
          </p>
          <p>
            We assume no responsibility for breakage or damage caused by our staff when asked to
            handle your personal property — please state any special requests when booking.
          </p>
          <p>
            100% removal of stains, odours or mould cannot be guaranteed; however, we use
            reasonable care and appropriate methods to achieve the best possible result.
          </p>
          <p>
            By clicking "Accept &amp; Confirm Booking" below, you acknowledge that you have read,
            understood and accepted these Terms &amp; Conditions in full.
          </p>
        </div>

        <div className="terms-modal-actions">
          <button type="button" className="terms-modal-decline" onClick={onDecline}>
            Decline
          </button>
          <button type="button" className="terms-modal-accept" onClick={onAccept}>
            Accept &amp; Confirm Booking
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsAcceptanceModal;
